import { combineReducers } from 'redux'

import templatePageFilters from './templatePageFilters'

export default combineReducers({
  templatePageFilters,
})
